/** @format */
import { Directive, ElementRef, EventEmitter, Injector, Input, Output } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { SelectCourseUnitAndCompletionMethodValues } from './selectCourseUnitAndCompletionMethodModal.component';

/**
 * @deprecated
 */
@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'select-course-unit-and-completion-method-modal',
    standalone: false,
})
export class SelectCourseUnitAndCompletionMethodModalDirective extends UpgradeComponent {
    @Output() close: EventEmitter<any>;
    @Input() resolve: SelectCourseUnitAndCompletionMethodValues;

    constructor(elementRef: ElementRef<any>, injector: Injector) {
        super('selectCourseUnitAndCompletionMethodModal', elementRef, injector);
    }
}
